module.exports = __webpack_public_path__ + "img/audio_icon.8941789e.svg";